import React from 'react';
import PropTypes from 'prop-types';
import { StyledImage, StyledImageWrapper } from './styled';

const Image = ({ alt, src, maxHeight, maxWidth }) => {
  return (
    <StyledImageWrapper
      maxWidth={maxWidth}
    >
      <StyledImage
        maxHeight={maxHeight}
        alt={alt}
        src={src}
      />
    </StyledImageWrapper>
  );
};

Image.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string.isRequired,
  maxHeight: PropTypes.string,
  maxWidth: PropTypes.string
};

export default React.memo(Image);
